module.exports = __webpack_public_path__ + "static/media/trout.88dc0a24.jpg";